import { addError } from './error';
import api from '../../helpers/ApiClient';

export const REQUEST_SHIPPING_RATE = 'REQUEST_SHIPPING_RATE';
export const RECEIVE_SHIPPING_RATE = 'RECEIVE_SHIPPING_RATE';
export const FAIL_SHIPPING_RATE = 'FAIL_SHIPPING_RATE';
export const CLEAR_SHIPPING_RATE = 'CLEAR_SHIPPING_RATE';

function receiveShippingRate(json, items, country, postCode) { 
  return {
    type: RECEIVE_SHIPPING_RATE,
    payload: {
      item: {
        ...json,
        lowestShippingMethod: json.shipping.length > 1 ? json.shipping.reduce((prev, cur) => {
          return prev.delivery_charges < cur.delivery_charges ? prev : cur;
        }) : json.shipping[0]
      },
      country,
      postCode,
      items,
      receivedAt: Date.now(),
    }
  };
}

function requestShippingRate(items, country, postCode) {
  return {
    type: REQUEST_SHIPPING_RATE,
    payload: {
      items,
      country,
      postCode,
    }
  };
}

function failShippingRate(items, country, postCode) {
  return {
    type: FAIL_SHIPPING_RATE,
    payload: {
      items,
      country,
      postCode,
    }
  };
}

function shouldFetchShippingRate(state, items, country, postCode) {
  if (!items || !items.length || !country || !postCode) {
    return false;
  }
  const results = state.shippingRate;
  if (results && results.loading) {
    return false;
  } else {
    return true;
  }
}

function fetchShippingRateFromApi(items, country, postCode) {
  return (dispatch, getState) => {
    const postItems = items.map(item => {
      return {
        article_number: item.article_number,
        quantity: item.quantity
      }
    });
    dispatch(requestShippingRate(postItems));
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: postItems,
        country,
        postcode: postCode
      })
    }
    return api(`/ikea/shipping/rates`, options)
      .then(json => {
        json = {
          ...json,
          shipping: json.shipping.filter(s => {
            return s !== null;
          })
        }
        if (json.manual_order) {
          const { form, cart, ticket } = getState();
          if (form && form.shipping && form.shipping.values) {
            createOrder(form.shipping.values, cart, ticket)
          }
        }
        //create order if json.manual_order
        return dispatch(receiveShippingRate(json, postItems, country, postCode))
      })
      .catch(err => {
        dispatch(failShippingRate(postItems, country, postCode));
        dispatch(addError(err));
      });
  };
}

export function fetchShippingRate(items, country, postCode) {
  return (dispatch, getState) => {
    if (shouldFetchShippingRate(getState(), items, country, postCode)) {
      return dispatch(fetchShippingRateFromApi(items, country, postCode));
    }
  };
}

export function clearShippingRate() {
  return {
    type: CLEAR_SHIPPING_RATE,
  };
}

function createOrder(shippingForm, cart, ticket) {
  const { name, address, city, postCode, state, country, email, contactNo } = shippingForm;
  const { items, file } = cart;
  const { ticketId } = ticket;
  return api('/api/order', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      address,
      city,
      postCode,
      state,
      country,
      email,
      contactNo,
      ticketId,
      shoppingListUrl: file,
      requireManualOrder: true,
      items: items.map(item => {
        return {
          article_number: item.article_number,
          quantity: item.quantity,
        }
      })
    })
  }).then(json => {
    return json;
  }).catch(err => {
    if (err) { 
      console.error('Failed to create manual order ', err)
    }
    return err;
  });
}